import { FormikProps } from 'formik';
import { Link } from 'react-router-dom';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMHTMLEditor from 'src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor';
import ATMMultiSelect from 'src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { WebCourseFormValues } from 'src/models/WebCourse.model';
import { handleValidNumber } from 'src/utils/validations/numberInput';

type Props = {
    formikProps: FormikProps<WebCourseFormValues>;
};
const courseSkillsOptions = [
    { label: "HTML", value: "HTML" },
    { label: "CSS", value: "CSS" },
    { label: "JAVASCRIPT", value: "JAVASCRIPT" },
    { label: "TAILWIND CSS", value: "TAILWIND_CSS" },
    { label: "REACT JS", value: "REACT_JS" },
    { label: "REDUX", value: "REDUX" },
    { label: "NEXT JS", value: "NEXT_JS" },
    { label: "STORY BOOK", value: "STORY_BOOK" },
    { label: "MONGODB", value: "MONGODB" },
    { label: "SQL", value: "SQL" },
    { label: "REDIS", value: "REDIS" },
    { label: "GIT", value: "GIT" },
    { label: "NODE JS", value: "NODE_JS" },
    { label: "EXPRESS JS", value: "EXPRESS_JS" },
    { label: "SOCKET IO", value: "SOCKET_IO" }
];
const AdditionalDescriptionForm = ({ formikProps }: Props) => {

    const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;

    return (
        <div className='w-full xl:w-[80%] mx-auto px-6 py-4 flex flex-col gap-4 !overflow-y-auto h-full'>
            <div className="z-0">
                <ATMTextField
                    required
                    name="totalReview"
                    value={values?.totalReview}
                    onChange={(e) => { handleValidNumber(e) && setFieldValue("totalReview", e.target.value) }}
                    label="Total Review"
                    placeholder="Enter Total Review"
                    onBlur={handleBlur}
                />
            </div>

            <div className="grid xl:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-6 items-center gap-4">
                <div>
                    <ATMMultiSelect
                        required
                        name="skills"
                        value={values.skills}
                        onChange={(newValue) => setFieldValue("skills", newValue)}
                        onBlur={handleBlur}
                        label="Skills"
                        placeholder="Select Skills"
                        options={courseSkillsOptions}
                    />
                </div>
                <ATMTextField
                    required
                    name="rating"
                    value={values?.rating}
                    onChange={(e) => {  setFieldValue("rating", e.target.value) }}
                    label="Rating"
                    placeholder="Enter rating"
                    onBlur={handleBlur}
                />
            </div>
            <div className="z-0">
                <ATMHTMLEditor
                    required
                    name="requirement"
                    label="Requirement"
                    value={values?.requirement}
                    placeholder="Write here...."
                    onChange={(newValue: any) => {
                        setFieldValue("requirement", newValue);
                    }}
                />
            </div>
            <div className='grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-6 items-center gap-4 mt-2'>
                <div>
                    <ATMTextField
                        required
                        name="color"
                        value={values?.color}
                        onChange={(e) => setFieldValue("color", e.target.value)}
                        label={`Color `}
                        placeholder="Enter Color"
                        onBlur={handleBlur}
                    />
                    <Link
                        to='https://cssgradient.io/'
                        target='_blank'
                        className='mt-4'
                    >
                        <span className='text-primary-main underline'>css gradient</span>
                    </Link>
                </div>
                <div
                    className="h-full rounded"
                    style={{
                        background: `linear-gradient(180deg, ${values.color})`,
                    }}
                />
            </div>
            <div className="flex justify-end">
                <ATMLoadingButton
                    className="w-[300px]"
                    isLoading={isSubmitting} type="submit">
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    )
}

export default AdditionalDescriptionForm